export default function CMalloc() {
  return <h2>C Malloc</h2>;
}
